import React from 'react';
import { Spinner } from '@volkswagen-onehub/components-core';

import {
  StyledCardsContainer,
  StyledInformationContainer,
  StyledSpinnerContainer,
  StyledUserSubscriptionsContainer,
  StyledUserVehiclesAndServicesContainer,
  StyledUserVehiclesContainer,
} from './styled';

import { CompleteVehicleCard } from '../../../../shared/components/vehicle-card/complete-vehicle-card/CompleteVehicleCard';
import { InformationBox } from '../../../../shared/components/information-box/InformationBox';
import ContentList from '../../../../shared/components/content-list';
import ContentListItem from '../../../../shared/components/content-list-item';
import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { SubscriptionCard } from '../../../../shared/components/subscription-card/SubscriptionCard';
import {
  Plan,
  SiriusXMSubscription,
  Vehicles,
} from '../../../../shared/typings/main';

interface RemoveVehicleAdditionalRoleProps {
  translationHandler: (key: string) => string;
  externalSubscriptions: any[];
  userVehicles: Vehicles[];
  deactivateButtons: Function;
  hasSiriusXMSubscription?: SiriusXMSubscription;
}

const RemoveVehicleAdditionalRole = ({
  translationHandler,
  externalSubscriptions,
  userVehicles,
  deactivateButtons,
  hasSiriusXMSubscription,
}: RemoveVehicleAdditionalRoleProps) => {
  return (
    <StyledUserVehiclesAndServicesContainer>
      <ContentList
        title={translationHandler(
          'vehicleManagement.removeVehicle.additional.title',
        )}
      >
        <ContentListItem>
          {applyTextTransformations(
            translationHandler(
              'vehicleManagement.removeVehicle.additional.firstContent',
            ),
            ['myVW'],
          )}
        </ContentListItem>
        <ContentListItem>
          {translationHandler(
            'vehicleManagement.removeVehicle.additional.secondContent',
          )}
        </ContentListItem>
      </ContentList>
      <StyledUserVehiclesContainer>
        <StyledInformationContainer>
          <InformationBox
            title={translationHandler(
              'vehicleManagement.removeVehicle.lose.title',
            )}
          />
        </StyledInformationContainer>
        <StyledCardsContainer hasDescription={false}>
          {userVehicles.length === 0 ? (
            <StyledSpinnerContainer>
              <Spinner />
            </StyledSpinnerContainer>
          ) : (
            userVehicles.map((vehicle: Vehicles) => (
              <CompleteVehicleCard
                id={vehicle.vehicleId}
                vehicle={vehicle}
                translationHandler={translationHandler}
                {...{ fromRemoveVehicle: true }}
              />
            ))
          )}
        </StyledCardsContainer>
      </StyledUserVehiclesContainer>
      {(externalSubscriptions.length > 0 || hasSiriusXMSubscription) && (
        <StyledUserSubscriptionsContainer>
          <InformationBox
            title={translationHandler(
              'vehicleManagement.removeVehicle.services.title',
            )}
            description={translationHandler(
              'vehicleManagement.removeVehicle.services.subscriptions.description',
            )}
          />
          <StyledCardsContainer hasDescription={true}>
            {externalSubscriptions.map((subscription: Plan, index: number) => (
              <SubscriptionCard
                id={`${subscription.package.sku || index + 1}`}
                planName={subscription.package.name || ''}
                providerName={subscription.provider.name || ''}
                translationHandler={translationHandler}
              />
            ))}
            {hasSiriusXMSubscription && (
              <SubscriptionCard
                id="SiriusXM-Subscription-Card"
                planName="SiriusXM"
                providerName="SiriusXM"
                translationHandler={translationHandler}
              />
            )}
          </StyledCardsContainer>
        </StyledUserSubscriptionsContainer>
      )}
      {deactivateButtons()}
    </StyledUserVehiclesAndServicesContainer>
  );
};

export default RemoveVehicleAdditionalRole;
